import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import {
  CollapsiblePanel,
  CollapsiblePanelWithActions,
  DetailField,
  Select,
  Checkbox,
  Button,
} from '@v2/components';
import type { SelectOption } from '@v2/components';
import { styles } from './styles';
import type { PimsDetailsProps } from './types';

const PimsDetails: React.FC<PimsDetailsProps> = ({
  pims,
  apps,
  appsLoading,
  onToggleConnectivity,
  connectivityLoading,
  onUpdateApp,
  appRelationLoading,
  onCreateConfig,
  configurationsCount,
  configurationsContent,
}) => {
  const appOptions: SelectOption[] = useMemo(
    () => apps.map(app => ({ value: app.id, label: app.name })),
    [apps],
  );

  return (
    <div className={styles.wrapper}>
      <CollapsiblePanel title="PIMS Information" defaultExpanded>
        <div className={styles.fieldGrid}>
          <DetailField label="Name">{pims.name}</DetailField>
          <DetailField label="Active Practices">{pims.activePracticeCount}</DetailField>
        </div>
      </CollapsiblePanel>

      <div className={styles.toggleRow}>
        <Checkbox
          label="Supports Connectivity"
          checked={pims.supportsConnectivity}
          onChange={onToggleConnectivity}
          disabled={connectivityLoading}
        />
      </div>

      <div className={styles.selectWrapper}>
        <Select
          label="App"
          options={appOptions}
          value={pims.appId}
          onChange={e => onUpdateApp(e.target.value)}
          disabled={appRelationLoading || appsLoading}
          placeholder={appsLoading ? 'Loading apps...' : 'Select an app'}
        />
      </div>

      <CollapsiblePanelWithActions
        title={`Configurations (${configurationsCount})`}
        description={`${configurationsCount} configuration(s)`}
        actions={
          <Button
            variant="ghost-success"
            size="sm"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={onCreateConfig}>
            New Config
          </Button>
        }>
        {configurationsContent}
      </CollapsiblePanelWithActions>
    </div>
  );
};

export { PimsDetails };
export default PimsDetails;
